(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collagen-lander"] && !Shopify.designMode) return;
  try {
    
  // FAQ accordion
  document.querySelectorAll('.lp-root .faq-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.lp-root .faq-item').forEach(function(i) {
        i.classList.remove('open');
        i.querySelector('.faq-btn').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Scroll-reveal for cards
  var revealEls = document.querySelectorAll(
    '.lp-root .benefit-card, .lp-root .testi-card, .lp-root .addon-card, .lp-root .step, .lp-root .hero-badge, .lp-root .pb-stat'
  );
  if ('IntersectionObserver' in window) {
    revealEls.forEach(function(el, i) {
      el.style.cssText += 'opacity:0; transform:translateY(18px); transition:opacity 0.5s ' + (i * 0.06) + 's ease, transform 0.5s ' + (i * 0.06) + 's ease;';
    });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function(el) { io.observe(el); });
  }

  // Navbar scroll shadow
  var lpNav = document.getElementById('lp-navbar');
  if (lpNav) {
    window.addEventListener('scroll', function() {
      lpNav.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,0.3)' : 'none';
    }, { passive: true });
  }

  // Mute/unmute Lauryn video
  var laurynVid = document.getElementById('lauryn-vid');
  var muteBtn   = document.getElementById('lauryn-mute-btn');
  if (laurynVid && muteBtn) {
    muteBtn.addEventListener('click', function() {
      laurynVid.muted = !laurynVid.muted;
      muteBtn.classList.toggle('is-unmuted', !laurynVid.muted);
      muteBtn.setAttribute('aria-label', laurynVid.muted ? 'Unmute video' : 'Mute video');
    });
  }

  // Paul video — click to play
  (function() {
    var btn     = document.getElementById('paul-play-btn');
    var vid     = document.getElementById('paul-video');
    var overlay = document.getElementById('paul-video-overlay');
    var poster  = document.getElementById('paul-poster');
    var block   = document.getElementById('paul-video-block');
    if (!btn || !vid) return;

    function showVideo() {
      poster.style.opacity  = '0';
      vid.style.opacity     = '1';
      block.classList.add('is-playing');
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
    }
    function showPoster() {
      vid.style.opacity     = '0';
      poster.style.opacity  = '1';
      block.classList.remove('is-playing');
      overlay.style.opacity = '1';
      overlay.style.pointerEvents = '';
    }
    function startPlay() {
      vid.currentTime = 0;
      vid.play();
      showVideo();
      vid.addEventListener('ended', function() { showPoster(); vid.currentTime = 0; vid.load(); }, { once: true });
    }

    btn.addEventListener('click', function(e) { e.stopPropagation(); startPlay(); });
    block.addEventListener('click', function() {
      if (!block.classList.contains('is-playing')) return;
      if (vid.paused) { vid.play(); showVideo(); } else { vid.pause(); showPoster(); }
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-v2"] && !Shopify.designMode) return;
  try {
    
  /**
   * Header V2 Component
   * Handles navigation dropdowns and mobile menu interactions
   */
  class HeaderV2 extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.activeDropdown = null;
    }

    connectedCallback() {
      this.initialize();
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    /**
     * Initialize component
     */
    initialize() {
      this.setupDesktopDropdowns();
      this.setupMobileMenu();
      this.setupKeyboardNav();
      this.setupClickOutside();
    }

    /**
     * Setup desktop dropdown interactions
     */
    setupDesktopDropdowns() {
      const triggers = this.querySelectorAll('[data-dropdown-trigger]');

      for (const trigger of triggers) {
        const dropdownId = trigger.dataset.dropdownTrigger;
        const dropdown = this.querySelector(`[data-dropdown="${dropdownId}"]`);

        if (!dropdown) continue;

        const navItem = trigger.parentElement;

        // Hover to open on desktop
        navItem.addEventListener(
          'mouseenter',
          () => {
            if (window.innerWidth >= 769) {
              this.openDropdown(trigger, dropdown);
            }
          },
          { signal: this.abortController.signal }
        );

        navItem.addEventListener(
          'mouseleave',
          () => {
            if (window.innerWidth >= 769) {
              this.closeDropdown(trigger, dropdown);
            }
          },
          { signal: this.abortController.signal }
        );

        // Enter key to toggle for keyboard users
        trigger.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.toggleDropdown(trigger, dropdown);
            }
          },
          { signal: this.abortController.signal }
        );
      }
    }

    /**
     * Toggle dropdown open/closed
     * @param {HTMLElement} trigger
     * @param {HTMLElement} dropdown
     */
    toggleDropdown(trigger, dropdown) {
      const isOpen = !dropdown.hasAttribute('hidden');

      if (isOpen) {
        this.closeDropdown(trigger, dropdown);
      } else {
        this.closeAllDropdowns();
        this.openDropdown(trigger, dropdown);
      }
    }

    /**
     * Open dropdown
     * @param {HTMLElement} trigger
     * @param {HTMLElement} dropdown
     */
    openDropdown(trigger, dropdown) {
      dropdown.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      this.activeDropdown = { trigger, dropdown };
    }

    /**
     * Close dropdown
     * @param {HTMLElement} trigger
     * @param {HTMLElement} dropdown
     */
    closeDropdown(trigger, dropdown) {
      dropdown.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
      if (this.activeDropdown?.dropdown === dropdown) {
        this.activeDropdown = null;
      }
    }

    /**
     * Close all dropdowns
     */
    closeAllDropdowns() {
      const dropdowns = this.querySelectorAll('.header-v2__dropdown');
      const triggers = this.querySelectorAll('[data-dropdown-trigger]');

      for (const dropdown of dropdowns) {
        dropdown.setAttribute('hidden', '');
      }

      for (const trigger of triggers) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      this.activeDropdown = null;
    }

    /**
     * Setup mobile menu toggle
     */
    setupMobileMenu() {
      const toggle = this.querySelector('.header-v2__mobile-toggle');
      const menu = this.querySelector('.header-v2__mobile-menu');

      if (!toggle || !menu) return;

      toggle.addEventListener(
        'click',
        () => {
          const isOpen = !menu.hasAttribute('hidden');

          if (isOpen) {
            // Close menu
            menu.setAttribute('hidden', '');
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', 'Open mobile menu');

            // Restore scroll
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
          } else {
            // Open menu
            menu.removeAttribute('hidden');
            toggle.setAttribute('aria-expanded', 'true');
            toggle.setAttribute('aria-label', 'Close mobile menu');

            // Lock scroll using overflow hidden
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
          }
        },
        { signal: this.abortController.signal }
      );
    }

    /**
     * Setup keyboard navigation
     */
    setupKeyboardNav() {
      document.addEventListener(
        'keydown',
        (e) => {
          // Escape to close dropdowns
          if (e.key === 'Escape') {
            this.closeAllDropdowns();

            // Close mobile menu
            const toggle = this.querySelector('.header-v2__mobile-toggle');
            const menu = this.querySelector('.header-v2__mobile-menu');
            if (toggle && menu && !menu.hasAttribute('hidden')) {
              menu.setAttribute('hidden', '');
              toggle.setAttribute('aria-expanded', 'false');

              // Restore scroll
              document.body.style.overflow = '';
              document.documentElement.style.overflow = '';
            }
          }
        },
        { signal: this.abortController.signal }
      );
    }

    /**
     * Close dropdowns when clicking outside
     */
    setupClickOutside() {
      document.addEventListener(
        'click',
        (e) => {
          if (!this.activeDropdown) return;

          const { trigger, dropdown } = this.activeDropdown;

          if (!trigger.contains(e.target) && !dropdown.contains(e.target)) {
            this.closeDropdown(trigger, dropdown);
          }
        },
        { signal: this.abortController.signal }
      );
    }

  }

  customElements.define('header-v2', HeaderV2);

  } catch(e) { console.error(e); }
})();
})();
